import { Injectable } from '@angular/core';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { Configuration, ExaTokenDto } from '../api/exa';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(
    private apiConfig: Configuration,
    private log: NGXLogger
  ) {}

  public init() {
    return new Promise<void>((resolve, reject) => {
      this.log.info('Init App...');
      this.apiConfig.basePath = environment.apiBasePath;
      this.log.updateConfig({ level: environment.logLevel, enableSourceMaps: true });
      this.log.debug('App Initialized, api server', environment.apiBasePath);
      resolve();
    });
  }

  public setApiToken(token: ExaTokenDto) {
    if (token) {
      this.log.debug('Set Api token', token);
      this.apiConfig.credentials.apiKey = 'Bearer ' + token.token;
    } else {
      this.log.debug('Remove Api token');
      this.apiConfig.credentials.apiKey = null;
    }
  }
}
